import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { CallbackPage } from './pages/CallbackPage'
import { WifiCredentialsPage } from './pages/WifiCredentialsPage'
import { RoleBasedHome } from './pages/RoleBasedHome'
import { CompaniesPage } from './pages/CompaniesPage'
import { CoworkersPage } from './pages/CoworkersPage'
import { GuestInvitationsPage } from './pages/GuestInvitationsPage'
import { WifiNetworksPage } from './pages/WifiNetworksPage'
import { WifiNetworkFormPage } from './pages/WifiNetworkFormPage'
import { CompanyFormPage } from './pages/CompanyFormPage'
import { BuildingsPage } from './pages/BuildingsPage'
import { BuildingFormPage } from './pages/BuildingFormPage'
import { RoomFormPage } from './pages/RoomFormPage'
import { WifiMonitorPage } from './pages/WifiMonitorPage'
import { AuditLogPage } from './pages/AuditLogPage'
import { ProfilePage } from './pages/ProfilePage'
import { NotEnrolledPage } from './pages/NotEnrolledPage'

export function App() {
  return (
    <Routes>
      <Route path="/callback" element={<CallbackPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <RoleBasedHome />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wifi"
        element={
          <ProtectedRoute>
            <Layout>
              <WifiCredentialsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/companies"
        element={
          <ProtectedRoute roles={['admin', 'operator']}>
            <Layout>
              <CompaniesPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/companies/new"
        element={
          <ProtectedRoute roles={['admin', 'operator']}>
            <Layout>
              <CompanyFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/companies/:id/edit"
        element={
          <ProtectedRoute roles={['admin', 'operator']}>
            <Layout>
              <CompanyFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/coworkers"
        element={
          <ProtectedRoute roles={['admin', 'operator']}>
            <Layout>
              <CoworkersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/guest-invitations"
        element={
          <ProtectedRoute roles={['admin', 'operator', 'user']}>
            <Layout>
              <GuestInvitationsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wifi-networks"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <WifiNetworksPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wifi-networks/new"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <WifiNetworkFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wifi-networks/:id/edit"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <WifiNetworkFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildings"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <BuildingsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildings/new"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <BuildingFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildings/:id/edit"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <BuildingFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildings/:buildingId/rooms/new"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <RoomFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildings/:buildingId/rooms/:roomId/edit"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <RoomFormPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/wifi-monitor"
        element={
          <ProtectedRoute roles={['admin', 'operator']}>
            <Layout>
              <WifiMonitorPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-log"
        element={
          <ProtectedRoute roles={['admin']}>
            <Layout>
              <AuditLogPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Layout>
              {({ darkMode, onToggleDarkMode }) => (
                <ProfilePage darkMode={darkMode} onToggleDarkMode={onToggleDarkMode} />
              )}
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/not-enrolled" element={<NotEnrolledPage />} />
    </Routes>
  )
}
